import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { MaterialStock } from '../../shared/models/core/material-stock.mode';
import { IProduct, IProductPk } from '../../shared/models/sale/product';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { BaseFilterSet } from '../../shared/models/base-filter-set';

export const materialApi = createApi({
  reducerPath: 'materialApi',
  baseQuery,
  endpoints: (builder) => ({
    getStock: builder.query<MaterialStock, IProductPk>({
      query: (id) => ({
        url: `/api/markets/${id.marketCode}/warehouses/${id.warehouseCode}/materials/${encodeURIComponent(encodeURIComponent(id.code))}/stock`,
        method: 'GET',
      }),
    }),
    getMaterials: builder.query<IPagedResult<IProduct>, BaseFilterSet>({
      query: (filter) => `materials?${serialize(filter)}`,
    }),
  }),
});

export const { useLazyGetStockQuery, useGetMaterialsQuery } = materialApi;
